import { useWizard } from "react-use-wizard";
import { EDealRequestViewType } from "../../../../../../shared/wizard/steps/types";
import { TKeyOfDataWizardSell, TStringKeysOfIFillDataWizardSell } from "../..";
import sellSteps from "../sellSteps";
import ViewRealtorParticipationStep from "../../../../../../shared/wizard/steps/viewRealtorParticipationStep";

interface IKnowPriceStep_4 {
  onChange: (
    data: EDealRequestViewType,
    key: TStringKeysOfIFillDataWizardSell
  ) => void;
  data: EDealRequestViewType | null;
  isNextStepDisabled: boolean;
  onReset: (key: TKeyOfDataWizardSell[]) => void;
}

const KnowPriceStep_4 = ({
  data,
  isNextStepDisabled,
  onChange,
  onReset,
}: IKnowPriceStep_4) => {
  const { goToStep } = useWizard();

  const handlePrevStep = () => {
    goToStep(sellSteps.knowPrice.step_3);
    onReset(["viewRealtorParticipation"]);
  };

  const handleNexStep = () => {
    goToStep(sellSteps.knowPrice.step_5);
  };

  return (
    <div>
      <ViewRealtorParticipationStep
        handlePrevStep={handlePrevStep}
        handleNexStep={handleNexStep}
        onChange={onChange}
        isNextStepDisabled={isNextStepDisabled}
        data={data}
        mode="sell"
      />
    </div>
  );
};

export default KnowPriceStep_4;
